// Контролер анімацій для централізованого управління
window.AnimationController = {
  // Зберігаємо всі функції ініціалізації секцій
  initFunctions: {},

  // Метод для реєстрації функції ініціалізації
  registerInitFunction: function(sectionName, initFunction) {
    this.initFunctions[sectionName] = initFunction;
    // Також додаємо функцію в глобальний об'єкт window для зворотної сумісності
    window['init' + sectionName + 'Animation'] = initFunction;
  },

  // Метод для ініціалізації конкретної секції
  initSection: function(sectionName) {
    if (this.initFunctions[sectionName]) {
      this.initFunctions[sectionName]();
      return true;
    }
    console.warn(`Функція ініціалізації для секції ${sectionName} не знайдена!`);
    return false;
  },

  // Метод для ініціалізації всіх зареєстрованих секцій
  initAllSections: function() {
    Object.keys(this.initFunctions).forEach(sectionName => {
      this.initSection(sectionName);
    });
  },

  // Функція для повного скидання всіх анімацій
  resetAllAnimations: function() {

    // Знищуємо всі ScrollTrigger інстанси
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill(true));
    }

    // Знищуємо всі GSAP анімації
    if (typeof gsap !== 'undefined') {
      gsap.killTweensOf("*");
    }

    // Очищаємо всі pin-spacer елементи
    this.cleanupPinSpacers();

    // Очищаємо всі inline стилі з анімованих елементів
    const animatedSections = document.querySelectorAll(
      '.custom-main-second-section, .custom-main-difference-section, ' +
      '.custom-main-standards-section, .custom-main-internal-section, ' +
      '.custom-main-invest-section, .custom-main-why-use-section, ' +
      '.custom-main-slider-section, .custom-main-faq-section, ' +
      '.standards-hero-section'
    );

    animatedSections.forEach(section => {
      if (!section) return;

      // Скидаємо стилі самої секції
      section.removeAttribute('style');

      // Скидаємо стилі всіх дочірніх елементів
      section.querySelectorAll('*').forEach(el => {
        if (el) el.removeAttribute('style');
      });
    });

    // Форсуємо оновлення DOM
    document.body.offsetHeight;
  },

  // Функція для очищення pin-spacer елементів
  cleanupPinSpacers: function() {
    const pinSpacers = document.querySelectorAll('.pin-spacer');

    if (pinSpacers.length === 0) return;

    Array.from(pinSpacers).reverse().forEach(spacer => {
      try {
        const pinnedElement = spacer.firstElementChild;

        if (pinnedElement) {
          pinnedElement.removeAttribute('style');
          spacer.parentNode.insertBefore(pinnedElement, spacer);
        }

        spacer.parentNode.removeChild(spacer);
      } catch (error) {
        console.error('Помилка при очищенні pin-spacer:', error);
      }
    });

    document.body.offsetHeight;
  }
};

// Глобальні аліаси для зручності
window.initializeAllAnimations = function() {
  window.AnimationController.initAllSections();
};

window.resetAllAnimations = function() {
  window.AnimationController.resetAllAnimations();
};

window.cleanupPinSpacers = function() {
  window.AnimationController.cleanupPinSpacers();
};

// Інструменти для діагностики
window.checkAnimationFunctions = function() {
  console.log('=== Перевірка доступності функцій анімації ===');
  console.log('initializeAllAnimations:', typeof window.initializeAllAnimations === 'function');
  console.log('resetAllAnimations:', typeof window.resetAllAnimations === 'function');
  console.log('cleanupPinSpacers:', typeof window.cleanupPinSpacers === 'function');
  console.log('initDifferenceSectionAnimations:', typeof window.initDifferenceSectionAnimations === 'function');
  console.log('initStandardsSectionAnimation:', typeof window.initStandardsSectionAnimation === 'function');
  console.log('initSecondSectionAnimations:', typeof window.initSecondSectionAnimations === 'function');
  console.log('AnimationController:', window.AnimationController);
  console.log('Зареєстровані функції:', Object.keys(window.AnimationController.initFunctions));
};

// Додаємо обробник події завантаження для перевірки функцій анімації
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    console.log('Перевірка функцій анімації після DOMContentLoaded:');
    if (typeof window.checkAnimationFunctions === 'function') {
      window.checkAnimationFunctions();
    }
  }, 500);
});

// Глобальний обробник зміни розміру вікна з оптимізацією
let globalResizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(globalResizeTimer);
  globalResizeTimer = setTimeout(function() {
    document.querySelector('body').classList.remove('is-animation-controller');
    console.log('Зміна розміру вікна - повне перезавантаження анімацій');
    if (typeof window.resetAllAnimations === 'function') {
      window.resetAllAnimations();
      setTimeout(() => {
        if (typeof window.initializeAllAnimations === 'function') {
          console.log('Запуск ініціалізації всіх анімацій після resize');
          window.initializeAllAnimations();
        }
      }, 100);
    }
  }, 300);
});
